import { post_data } from "./functions";

export async function checkPDFCreation(name) {
  const form = new FormData();
  form.append(
    "data",
    JSON.stringify({ function: "check_pdf_creation", name })
  );
  const response = await post_data("./includes/ajax.inc.php", form);
  return response;
}

export function createIframeForPDFCreation(id) {
  const iframe = document.createElement("iframe");
  const basePath = location.href.split("/editor")[0];
  iframe.src = `${basePath}/pdf-document.php?id=${id}&publishing=1`;
  iframe.style.display = "none";
  document.body.appendChild(iframe);
}
